const pixKeyType = require('@transfeeradev/api-enums/pix/keyType');
const { regexes } = require('@transfeeradev/api-enums');
const PersonTypeService = require('./PersonTypeService');
const UtilsService = require('./UtilsService');
const PixKeyValidationService = require('./PixKeyValidationService');

class PixKeyFormatterService {
  static formatPhoneKey(key) {
    key = UtilsService.getNumbersFromStr(key);
    if (!key || !regexes.MOBILE_PHONE.test(key)) {
      return null;
    }

    if (key.length === 11) {
      key = '55' + key;
    }
    if (key.length === 13) {
      key = '+' + key;
    }
    return key;
  }

  static formatEvpKey(key) {
    key = key.toLowerCase().replace(/[^a-f0-9]/g, '');
    if (!key || key.length !== 32) {
      return null;
    }

    return (
      key.slice(0, 8) +
      '-' +
      key.slice(8, 12) +
      '-' +
      key.slice(12, 16) +
      '-' +
      key.slice(16, 20) +
      '-' +
      key.slice(20, 32)
    );
  }

  static formatEmailKey(key) {
    key = key.toLowerCase();
    if (!regexes.PIX_EMAIL.test(key)) {
      return null;
    }

    return key;
  }

  static format(key, keyType) {
    key = key ? key.trim() : null;
    const formatter = {
      [pixKeyType.CPF]: key => (PersonTypeService.isValidCPF(key) ? PersonTypeService.getCpfCnpjNumber(key) : null),
      [pixKeyType.CNPJ]: key => (PersonTypeService.isValidCNPJ(key) ? PersonTypeService.getCpfCnpjNumber(key) : null),
      [pixKeyType.EMAIL]: key => PixKeyFormatterService.formatEmailKey(key),
      [pixKeyType.CHAVE_ALEATORIA]: key => PixKeyFormatterService.formatEvpKey(key),
      [pixKeyType.TELEFONE]: key => PixKeyFormatterService.formatPhoneKey(key)
    };

    key = key && formatter[keyType] ? formatter[keyType](key) : null;
    return key || null;
  }

  static addBrazilCountryCodeToPhonePixKey(key) {
    let formattedKey = UtilsService.getNumbersFromStr(key);
    if (PixKeyValidationService.isValidPhonePixKey(key)) {
      return key;
    }

    if (!key || !PixKeyValidationService.isValidPhoneWithoutCountryCode(key)) {
      throw new Error(`Phone pix key ${key} is invalid format`);
    }

    if (formattedKey.length === 11) {
      formattedKey = '+55' + formattedKey;
    }

    return formattedKey;
  }

  static removeBrazilCountryCodeFromPhonePixKey(key) {
    let formattedKey = UtilsService.getNumbersFromStr(key);
    if (!formattedKey || !regexes.MOBILE_PHONE.test(key)) {
      throw new Error(`Phone pix key ${key} is invalid format`);
    }

    if (formattedKey.length === 13) {
      formattedKey = formattedKey.substring(2);
    }
    return formattedKey;
  }

  static encodeKeyAsURI(key) {
    if (PixKeyValidationService.identifyPixKeyType(key) !== pixKeyType.EMAIL) {
      return key;
    }

    return encodeURIComponent(key);
  }
}

module.exports = PixKeyFormatterService;
